"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../constants");
exports.default = theme => ({
    root: {
        width: 21,
        height: 21,
        display: 'flex',
        justifyContent: 'center',
        borderRadius: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        cursor: 'default',
        outline: 'none',
        marginLeft: 7,
        boxShadow: `0 0 0 0 ${theme.indigoPastel2}`,
        transition: `box-shadow 150ms linear, background-color 150ms linear, border-color 150ms linear`,
        color: theme.indigo3,
        borderColor: 'currentColor',
        backgroundColor: 'transparent',
        '&:not([disabled]):hover': {
            color: theme.white1,
            backgroundColor: theme.indigo2,
            borderColor: theme.indigo2,
            cursor: 'pointer'
        },
        '&[disabled]': {
            opacity: 0.3
        },
        '&:focus': {
            boxShadow: `0 0 0 ${constants_1.FOCUS_OUTLINE_WIDTH}px ${theme.indigoPastel2}`
        },
        '&[data-is-active="true"]': {
            color: theme.white1,
            backgroundColor: theme.indigo2,
            borderColor: theme.indigo2
        }
    },
    text: {
        color: 'currentColor',
        fontSize: 12,
        fontWeight: 800,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        height: '100%',
        width: '100%',
        textAlign: 'center'
    }
});
//# sourceMappingURL=button.style.js.map